import { useMemo } from 'react'
import constants from 'config/constants'
import usePermission from 'hooks/usePermission'
import {
  getBaseFilterCustomDashboardOptions,
  getBaseFilterSurveyDashboardOptions,
  getBaseFilterFeedbackOptions,
  getBaseFilterReportOptions,
} from './constants'
import useCustomAttributeOptions from 'hooks/useCustomAttributeOptions'
import useFeatureToggle from 'hooks/useFeatureToggle'
import useCollaboratorRoleOptions from 'hooks/useCollaboratorRoleOptions'
import * as R from 'ramda'

export default function useFilterOptions(pageName) {
  const { hasPermission } = usePermission()
  const { enableFileUploadQuestion } = useFeatureToggle()
  const customAttributeOptions = useCustomAttributeOptions() || []
  const collaboratorRoleOptions = useCollaboratorRoleOptions() || []

  const canViewTeamMemberGroup = hasPermission(constants.permissions.viewTeamMembers)

  return useMemo(() => {
    let filterOptions = []
    const map = {
      report: getBaseFilterReportOptions(),
      surveyDashboard: getBaseFilterSurveyDashboardOptions(),
      feedback: getBaseFilterFeedbackOptions(),
      customDashboard: getBaseFilterCustomDashboardOptions(),
    }
    const baseFilterOptions = map[pageName] || []
    const baseFilterWithCustomAttrAndRoleOptions = [
      ...baseFilterOptions,
      ...customAttributeOptions,
      ...collaboratorRoleOptions,
    ]

    if (!canViewTeamMemberGroup) {
      filterOptions = R.reject(
        R.propEq('field', 'team_member.group'),
        baseFilterWithCustomAttrAndRoleOptions
      )
    } else {
      filterOptions = baseFilterWithCustomAttrAndRoleOptions
    }

    if (!enableFileUploadQuestion) {
      filterOptions = R.reject(R.propEq('field', 'attachment'), filterOptions)
    }

    return filterOptions
  }, [
    pageName,
    canViewTeamMemberGroup,
    enableFileUploadQuestion,
    customAttributeOptions,
    collaboratorRoleOptions,
  ])
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/hooks/useFilterOptions/index.js